import { extends as _extends, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useRef, useEffect } from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import cx from 'classnames';
import intlTelInput from 'intl-tel-input';
import Boutton from '@piconetworks/pkg-boutton';
import Form from '@piconetworks/pkg-form';
import styles from './scss/TextSignup.module.scss.js';

var _excluded = ["meta", "input"];
var PhoneField = function PhoneField(_ref) {
  var _window, _window$iti;
  var checkPhone = _ref.checkPhone,
    contrastColor = _ref.contrastColor,
    enterOTP = _ref.enterOTP,
    fieldContainerProps = _ref.fieldContainerProps,
    isReturningUser = _ref.isReturningUser,
    oneTimeCodeError = _ref.oneTimeCodeError,
    _ref$onSubmitCallback = _ref.onSubmitCallback,
    onSubmitCallback = _ref$onSubmitCallback === void 0 ? function () {} : _ref$onSubmitCallback,
    previewMode = _ref.previewMode,
    userPhoneMismatchError = _ref.userPhoneMismatchError,
    _ref$isCustomFieldsVa = _ref.isCustomFieldsValid,
    isCustomFieldsValid = _ref$isCustomFieldsVa === void 0 ? true : _ref$isCustomFieldsVa,
    setFlow = _ref.setFlow,
    values = _ref.values,
    _errorMessage = _ref.errorMessage,
    getErrorText = _ref.getErrorText,
    isAuthenticated = _ref.isAuthenticated;
  var _useState = useState(_errorMessage),
    errorMessage = _useState[0],
    setErrorMessage = _useState[1];
  var _useState2 = useState(null),
    phoneInputError = _useState2[0],
    setPhoneInputError = _useState2[1];
  var phoneInputRef = useRef(null);
  useEffect(function () {
    if (phoneInputRef !== null && phoneInputRef !== void 0 && phoneInputRef.current) {
      var iti = intlTelInput(phoneInputRef.current, {
        initialCountry: 'us',
        onlyCountries: ['us', 'ca'],
        preferredCountries: ['us'],
        utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.3/build/js/utils.js'
      });
      window.iti = iti;
    }
  }, [phoneInputRef.current]);
  useEffect(function () {
    setErrorMessage(_errorMessage);
  }, [_errorMessage]);
  useEffect(function () {
    if (oneTimeCodeError) {
      setErrorMessage(oneTimeCodeError);
    }
  }, [oneTimeCodeError]);
  useEffect(function () {
    setPhoneInputError(userPhoneMismatchError);
  }, [userPhoneMismatchError]);
  var error = phoneInputError || errorMessage;
  var number = ((_window = window) === null || _window === void 0 ? void 0 : (_window$iti = _window.iti) === null || _window$iti === void 0 ? void 0 : _window$iti.getNumber()) || null;
  var shouldShowError = function shouldShowError(phoneInput) {
    // intl-input number validates numbers with letters if it fits the country's
    // number length, so we must check the raw input as well as the formatted input
    // they provide. shouldShowError is true if intl-input number validation does not pass
    // or input value contains anything other than +-() and numbers
    return number && !window.iti.isValidNumber() || !/^(?=.*[0-9])[- +()0-9]+$/.test(phoneInput);
  };
  var resolvePhoneInputError = function resolvePhoneInputError() {
    switch (window.iti.getValidationError()) {
      case 1:
        return 'Invalid Country Code';
      case 2:
        return 'Number is too short';
      case 3:
        return 'Number is too long';
      case 5:
        return 'Number length is invalid';
      default:
        return 'Invalid number';
    }
  };
  var handlePhoneErrorReset = function handlePhoneErrorReset() {
    if (error) {
      setErrorMessage(null);
      setPhoneInputError(null);
    }
  };
  var processNumber = async function processNumber(phone) {
    phone = phone && phone.trim();
    if (isCustomFieldsValid || isReturningUser) {
      setFlow(Object.assign({
        flow: 'sms'
      }, values));
      if (shouldShowError(phone)) {
        var _error = resolvePhoneInputError();
        setPhoneInputError(_error);
      } else {
        try {
          await checkPhone({
            phone: number || phone,
            shouldUpdate: isAuthenticated
          });
          enterOTP();
        } catch (error) {
          setErrorMessage(error.message);
        }
      }
    } else {
      setErrorMessage('Please fill out the required fields above.');
    }
  };
  var onEnterPhone = function onEnterPhone(e, phone) {
    if (e.key === 'Enter') {
      e.preventDefault();
      processNumber(phone);
    }
  };
  var disabled = !!error;
  var renderSignupButton = function renderSignupButton() {
    var _phoneInputRef$curren2, _phoneInputRef$curren3, _cx;
    return /*#__PURE__*/React.createElement(Boutton, {
      variant: "primary",
      onClick: function onClick(e) {
        var _phoneInputRef$curren;
        e.preventDefault();
        var phoneValue = phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren = phoneInputRef.current) === null || _phoneInputRef$curren === void 0 ? void 0 : _phoneInputRef$curren.value;
        if (!previewMode) {
          if (!isReturningUser) {
            onSubmitCallback({
              end_user_phone: phoneValue,
              sign_up_method: 'sms'
            });
          }
          processNumber(phoneValue);
        }
      },
      disabled: !previewMode && (typeof (phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren2 = phoneInputRef.current) === null || _phoneInputRef$curren2 === void 0 ? void 0 : _phoneInputRef$curren2.value) === 'undefined' || (phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren3 = phoneInputRef.current) === null || _phoneInputRef$curren3 === void 0 ? void 0 : _phoneInputRef$curren3.value) === '') || disabled,
      styles: {
        color: contrastColor
      },
      className: cx(styles.signupButton, (_cx = {}, _cx[styles.loginButton] = isReturningUser, _cx))
    }, "Continue");
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.field
  }, /*#__PURE__*/React.createElement(Field, _extends({}, fieldContainerProps, {
    name: "phone",
    id: "phone",
    type: "tel"
  }), function (_ref2) {
    var meta = _ref2.meta,
      input = _ref2.input,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
    return /*#__PURE__*/React.createElement("div", {
      className: styles["phoneInput" + (error ? '--error' : '')]
    }, /*#__PURE__*/React.createElement(Form.Input, _extends({}, rest, {
      meta: meta,
      ref: phoneInputRef,
      input: input,
      onClick: function onClick() {
        handlePhoneErrorReset();
      },
      onChange: function onChange() {
        handlePhoneErrorReset();
      },
      onKeyDown: function onKeyDown(e) {
        return onEnterPhone(e, e.target.value);
      }
    })), error && /*#__PURE__*/React.createElement("span", {
      className: styles.phoneError
    }, getErrorText(error)));
  })), /*#__PURE__*/React.createElement("div", null, renderSignupButton()));
};
PhoneField.propTypes = {
  checkPhone: PropTypes.func,
  contrastColor: PropTypes.string,
  enterOTP: PropTypes.func,
  errorMessage: PropTypes.string,
  fieldContainerProps: PropTypes.any,
  getErrorText: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  isCustomFieldsValid: PropTypes.bool,
  isReturningUser: PropTypes.bool,
  oneTimeCodeError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onSubmitCallback: PropTypes.func,
  previewMode: PropTypes.bool,
  setFlow: PropTypes.func,
  userPhoneMismatchError: PropTypes.string,
  values: PropTypes.object
};
var MemoizedPhoneField = /*#__PURE__*/React.memo(PhoneField);
MemoizedPhoneField.displayName = 'FieldSignupPhone';
var PhoneField$1 = MemoizedPhoneField;

export { PhoneField$1 as default };
//# sourceMappingURL=PhoneField.js.map
